const Facebook = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25">
      <path
        fill="#CFCFCF"
        fillRule="evenodd"
        d="M13.191 21.351v-7.688h2.584l.39-2.997h-2.966V8.754c0-.867.243-1.459 1.483-1.459h1.588V4.614c-.276-.032-1.216-.122-2.31-.122-2.284 0-3.855 1.394-3.855 3.962v2.212H7.52v2.997h2.585v7.688h3.086z"
      />
    </svg>
  );
};

export default Facebook;
